import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { BackToTop } from '@components/back-to-top';
import { CoverageLimits } from '@components/shared/coverage-limits';
import { CustomersGet } from '@components/shared/customers-get';
import { FAQ } from '@components/shared/faq';
import { Hero } from '@components/shared/hero';
import { HowItWorks } from '@components/shared/how-it-works';
import { MaintenanceCredit } from '@components/shared/maintenance-credit';

@Component({
  selector: 'hsc-info-page',
  imports: [CommonModule, Hero, HowItWorks, CustomersGet, MaintenanceCredit, FAQ, BackToTop, CoverageLimits],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <hsc-hero></hsc-hero>
    <hsc-how-it-works></hsc-how-it-works>
    <hsc-customers-get></hsc-customers-get>
    <hsc-coverage-limits />
    <hsc-maintenance-credit></hsc-maintenance-credit>
    <hsc-faq></hsc-faq>
    <hsc-back-to-top></hsc-back-to-top>
  `,
})
export class InfoPage {}
